import angular from 'angular';

module.exports = angular.module('common.filters', [
  require('./abs'),
  require('./address'),
  require('./any'),
  require('./arrayDiff'),
  require('./assignee-photo'),
  require('./bathroom-count'),
  require('./bytes'),
  require('./capitalize'),
  require('./contains'),
  require('./currency'),
  require('./customer'),
  require('./days-from-now'),
  require('./days-on-market'),
  require('./display-owner-name'),
  require('./duration'),
  require('./features'),
  require('./first-name'),
  require('./image-url'),
  require('./implied-price-cents'),
  require('./implied-price-per-sqft'),
  require('./implied-price-percentage-change'),
  require('./in'),
  require('./isNil'),
  require('./join'),
  require('./kebabcase'),
  require('./length'),
  require('./letterize'),
  require('./listing-display-address'),
  require('./listing-state'),
  require('./lodash-filter'),
  require('./map'),
  require('./min-selected'),
  require('./moment-to-date'),
  require('./moment-from-now'),
  require('./newlines'),
  require('./none-selected'),
  require('./noop'),
  require('./order-object-by'),
  require('./percentage'),
  require('./pluralize'),
  require('./pretty'),
  require('./readable-list'),
  require('./relative-distance'),
  require('./short-name'),
  require('./sign'),
  require('./some'),
  require('./sorted-keys'),
  require('./split'),
  require('./status-date'),
  require('./street'),
  require('./stringify-filters'),
  require('./stringify-parking-types'),
  require('./stringify-pool-types'),
  require('./sum'),
  require('./tel'),
  require('./tel-href'),
  require('./titlecase'),
  require('./trimmed-number'),
  require('./tz_format'),
  require('./uniqBy'),
  require('./url-encode'),
  require('./use-filter'),
  require('./valuation-route'),
  require('./values'),
  require('./wordcase'),
  require('./years-old'),
  require('./yes_no'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/index.js
 **/